import { push, replace } from "connected-react-router";
import { LocationState } from "history";
import { getParentFullPath, getParentPath } from "./PathUtils";
import { AppAction } from "@my-dld/actions";
import { getAppServices } from "@10x/coreapp/index";


export function dispatch( action: string, payload?: any ) {
	getAppServices().storeService.dispatch( { type: action, payload: payload } );
}

export function dispatchX( action: AppAction ) {
	getAppServices().storeService.dispatch( action );
}

export function navigate( path: string, query?: string, state?: LocationState ) {
	let action = push( {
		pathname: path,
		state: state,
		search: query,
	} );
	getAppServices().storeService.dispatch( action );
}

export function replaceNavigate( path: string, query?: string, state?: LocationState ) {
	let action = replace( {
		pathname: path,
		state: state,
		search: query,
	} );
	getAppServices().storeService.dispatch( action );
}

export function getCurrentPath() {
	return getAppServices().storeService.getStore().getState().router.location.pathname;
}

export function navigateWithInParent( parent: string, dest: string, query?: string, state?: LocationState ) {
	const store = getAppServices().storeService.getStore();
	const currentPath = store.getState().router.location.pathname;
	let path = getParentFullPath( currentPath, parent );
	path = path + "/" + dest;
	let action = push( {
		pathname: path,
		state: state,
		search: query,
	} );
	store.dispatch( action );
}

export function navigateWithSibling( sibling: string, dest: string, query?: string, state?: LocationState ) {
	const store = getAppServices().storeService.getStore();
	const currentPath = store.getState().router.location.pathname;
	let path = getParentPath( currentPath, sibling );
	path = path + "/" + dest;
	let action = push( {
		pathname: path,
		state: state,
		search: query,
	} );
	store.dispatch( action );
}
